<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">报案号:</div>
                <el-input v-model="conditionData.CClmNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">保单号:</div>
                <el-input v-model="conditionData.CPlyNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">出险人:</div>
                <el-input v-model="conditionData.personDanger" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">案件状态:</div>
                 <el-select v-model="conditionData.DcTaskActions" multiple size="small" placeholder="请选择" class="input">
                    <el-option
                    v-for="item in DcTaskActionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <!-- <div class="item">
                <div class="label">财务状态:</div>
                 <el-select v-model="conditionData.FinanceStates" multiple size="small" placeholder="请选择" class="input">
                    <el-option
                    v-for="item in financeStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div> -->

            <!-- <div class="item">
                <div class="label">保险公司:</div>
                <el-select v-model="conditionData.CompanyId" size="small" placeholder="请选择"  class="citem-input" filterable @change="changeCompany">
                    <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div> -->
            <div class="item">
                <div class="label">提交时间:</div>
                <el-date-picker
                v-model="conditionData.DcTaskCommitStartTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.DcTaskCommitEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            <div class="item">
                <div class="label">派工时间:</div>
                <el-date-picker
                v-model="conditionData.DcTaskPgStartTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
                ——
                <el-date-picker
                v-model="conditionData.DcTaskPgEndTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
                </el-date-picker>
            </div>

            <div class="item">
                <div class="label">险种类型:</div>
                 <el-select v-model="conditionData.CProdTypes" size="small" placeholder="请选择" class="input" multiple>
                    <el-option
                    v-for="item in insuranceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
               
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                prop="dcTaskPgMechanism"
                label="展业机构"
                align="center"
                width="160px"
                >
                <template slot-scope="scope">
                   
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.dcTaskPgMechanism}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cClmNo"
                label="赔案号"
                align="center"
                width="160px"
                >
                <template slot-scope="scope">
                   
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cClmNo}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="personDanger"
                label="出险人"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.personDanger}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cProdType"
                label="险种类型"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cProdType}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="companyName"
                label="保险公司名称"
                align="center"
                width="200px"
                >
                <template slot-scope="scope">
                    
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.companyName}}
                    </span>
                </template>
                </el-table-column>
                
                
                <el-table-column
                prop="dcTaskPgTime"
                label="派工时间"
                align="center"
                width="160px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.dcTaskPgTime}}
                    </span>
                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="creationTime"
                label="指派时间"
                align="center"
                width="160px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs&&scope.row.executeAction!=50?'tb-red':''">
                        {{scope.row.creationTime}}
                    </span>
                </template>
                </el-table-column> -->
                <el-table-column
                prop="cSvyMode"
                label="案件时限"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.cSvyMode}}
                    </span>
                </template>
                </el-table-column>
                <el-table-column
                prop="pgTs"
                label="派工天数"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.pgTs}}
                    </span>
                </template>
                </el-table-column>
                
                
                <el-table-column
                prop="caseProgress"
                label="案件进度"
                align="center"
                width="100px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.caseProgress}}
                    </span>
                </template>
                </el-table-column>
                
                <el-table-column
                prop="dcTaskAction"
                label="案件状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">

                    <span v-if="scope.row.dcTaskAction==0" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">新案件</span>
                    <span v-else-if="scope.row.dcTaskAction==10" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件待派机构</span>
                    <span v-else-if="scope.row.dcTaskAction==20" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件作业中</span>
                    <span v-else-if="scope.row.dcTaskAction==21" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">展业案件审核</span>
                    <span v-else-if="scope.row.dcTaskAction==25" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件待总部审核</span>
                    <span v-else-if="scope.row.dcTaskAction==26" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">待回复委托主体</span>
                    <span v-else-if="scope.row.dcTaskAction==30" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件已回复委托主体</span>
                    <span v-else-if="scope.row.dcTaskAction==60" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件委托主体退回</span>
                    <span v-else-if="scope.row.dcTaskAction==50" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件结案</span>
                    <span v-else-if="scope.row.dcTaskAction==40" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">案件完成</span>
                    <span v-else-if="scope.row.dcTaskAction==70" :class="scope.row.sx<scope.row.pgTs?'tb-red':''">取消委托</span>

                </template>
                </el-table-column>
                <!-- <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="120px"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==0">未开票未回款</span>
                    <span v-else-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-else-if="scope.row.financeState==20">已开票部分回款</span>
                    <span v-else-if="scope.row.financeState==30">回款完成</span>
                    <span v-else-if="scope.row.financeState==40">回款未开票</span>
                    <span v-else-if="scope.row.financeState==50">红冲</span>
                    <span v-else-if="scope.row.financeState==60">作废</span>
                </template>
                </el-table-column> -->
                <!-- <el-table-column
                prop="operatorMechanisms"
                label="作业机构"
                align="center"
                width="180px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.operatorMechanisms}}
                    </span>
                </template>

                </el-table-column> -->
                
                <!-- <el-table-column
                prop="rejectNum"
                label="退回次数"
                align="center"
                width="80px"
                >
                <template slot-scope="scope">
                    <span :class="scope.row.sx<scope.row.pgTs?'tb-red':''">
                        {{scope.row.rejectNum}}
                    </span>
                </template>
                </el-table-column> -->

                <el-table-column
                fixed="right"
                label="操作"
                width="220px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="task(scope.row)">案件工作台</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTask(scope.row)" v-if="scope.row.sourceType!=2&&scope.row.dcTaskAction!=70&&scope.row.dcTaskAction!=50">案件派工编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelTaskTip(scope.row)" v-if="scope.row.dcTaskAction!=30&&scope.row.dcTaskAction!=40&&scope.row.dcTaskAction!=50&&scope.row.dcTaskAction!=70&&isCancel">取消委托</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>



      
        
    </div>
</template>
<script>
import api from '../../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
import { insuranceList,DcTaskActionLists,financeStateLists} from "../../../../assets/selectList/anxin";

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            financeStateList:financeStateLists,
            DcTaskActionList:DcTaskActionLists,
            insuranceList:insuranceList,
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                Keyword:'',
                CClmNo:'',
                CPlyNo:'',
                DcTaskActions:[],
                FinanceStates:[],
                CompanyId:'',
                CompanyName:'',
                DcTaskCommitStartTime:'',
                DcTaskPgStartTime:'',
                DcTaskCommitEndTime:'',
                DcTaskPgEndTime:'',
                ZpMechanismId:'',
                CProdTypes:[],
                personDanger:'',
                page:1,
                pageSize:10,
            },
            companyList:[],
            isCancel:false,

            myMechanism:localStorage.getItem('mechanism')

        }
    },
    created(){
        this.btnsList = JSON.parse(localStorage.getItem('btns'));
        for(let index in this.btnsList){
            if(this.btnsList[index].name == '取消委托'&&this.btnsList[index].isCheck){
                this.isCancel = true;
            }
        }
        console.log(localStorage.getItem('taskStatus'));
        this.loadingData();
        this.getCompanyList();
        
    },
    mounted(){
    },
    methods:{
        async getCompanyList() {
            let res  = await api.queryCompany({
                page:1,
                pageSize:100,
            });
            console.log(res);
            this.companyList = res.data.data;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let option = {
                Keyword:this.conditionData.Keyword,
                CClmNo:this.conditionData.CClmNo,
                CPlyNo:this.conditionData.CPlyNo,
                DcTaskActions:this.conditionData.DcTaskActions,
                FinanceStates:this.conditionData.FinanceStates,
                CompanyId:this.conditionData.CompanyId,
                CompanyName:this.conditionData.companyName,
                DcTaskCommitStartTime:this.conditionData.DcTaskCommitStartTime,
                DcTaskPgStartTime:this.conditionData.DcTaskPgStartTime,
                DcTaskCommitEndTime:this.conditionData.DcTaskCommitEndTime,
                DcTaskPgEndTime:this.conditionData.DcTaskPgEndTime,
                ZpMechanismId:this.conditionData.ZpMechanismId,
                CProdTypes:this.conditionData.CProdTypes,
                personDanger:this.conditionData.personDanger,
                page:this.conditionData.page,
                pageSize:this.conditionData.pageSize,
            }
            for(let index in this.conditionData.FinanceStates){
                if(this.conditionData.FinanceStates[index] == -2){
                    option.FinanceStates = [];
                    break;
                }
            }
            for(let index in this.conditionData.DcTaskActions){
                if(this.conditionData.DcTaskActions[index] == -2){
                    option.DcTaskActions = [];
                    break;
                }
            }
            for(let index in this.conditionData.CProdTypes){
                if(this.conditionData.CProdTypes[index] == -2){
                    option.CProdTypes = [];
                }
            }
            let res  = await api.QueryPageInsupAdminDcTask(option);
            
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        changeCompany(e){

let resultArr = this.companyList.filter((item)=>{
  return item.id === e
});
this.conditionData.companyName = resultArr[0].name

},
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                Keyword:'',
                CClmNo:'',
                CPlyNo:'',
                DcTaskActions:[],
                FinanceStates:[],
                CompanyId:'',
                DcTaskCommitStartTime:'',
                DcTaskPgStartTime:'',
                DcTaskCommitEndTime:'',
                DcTaskPgEndTime:'',
                ZpMechanismId:'',
                CProdTypes:[],
                FinanceState:null,
                personDanger:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },
        async auditTip(row){
            console.log(row);
            this.$confirm('是否接受此案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.examineTask(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async examineTask(row){
            let option = {
                id:row.id,
                taskSate:20
            };
            let res  = await api.examineTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async task(row){
            console.log(row);
            if(this.myMechanism == row.dcTaskPgMechanism){
                const { href } = this.$router.resolve({
                    name: "caseDetailinsup",
                    query:{
                        id:row.id,
                        isNoaAgrent:1,
                    }
                });
                window.open(href, '_blank');
            }else{
                const { href } = this.$router.resolve({
                    name: "caseDetailinsup",
                    query:{
                        id:row.doubtTaskId,
                        anXinDcTaskId:row.id,
                    }
                });
                window.open(href, '_blank');
            }
            
        },
        editTask(row){
            console.log(row);
            this.$emit('addAnXinCase',{
                router:'editCase',
                name:'编辑案件',
                index:'1-201',
                id:row.id
            });
            this.$router.push({
                name:'editCase',
                query:{
                    id:row.id
                }
            })
        },
        async showAddDialog(){
            this.$router.push({name:'addCase'})
        },
        async exportInventory(){

            this.conditionData.OperatorMechanismId = localStorage.getItem('mechanismid'),
            this.conditionData.DcTaskPgMechanismId = localStorage.getItem('mechanismid')
            this.conditionData.ZpMechanismId = localStorage.getItem('mechanismid');
            if(localStorage.getItem('mechanism')=='广州天信保险公估有限公司'){
                let res = await api.exportInventory({
                    "type": 1,
                    "Condition":this.conditionData
                });
            }else{
                let res = await api.exportInventoryMer({
                    "type": 1,
                    "Condition":this.conditionData
                });
            }
            
        },

        cancelTaskTip(row){
            console.log(row);
            this.$confirm('是否取消此案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.updateDcTaskAction(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },

        async updateDcTaskAction(id){
            let res = await api.anXinDcTaskUpdateDcTaskAction({
                anXinDcTaskId:id,
                dcTaskAction:70,
            });
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '取消成功'
                });  
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .tb-red{
            color:red;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
